<ion-content class="modal-outher-container" scrollbar *ngIf="!loading">
  <div class="modal-inner-container">
    <div class="ion-padding">
      <app-modal-header
        *ngIf="idEquipment == 0"
        header="{{ 'EQUIPMENT.NEW' | translate }}"
        (close)="close()"
      >
      </app-modal-header>

      <app-modal-header
        *ngIf="idEquipment != 0"
        header="{{ 'EQUIPMENT.EDIT' | translate }}"
        (close)="close()"
      >
      </app-modal-header>

      <form [formGroup]="form" class="w-100">
        <app-input
          type="input"
          [form]="form"
          formControlName="name"
          label="NAME"
          [submittedError]="validationError"
        ></app-input>

        <div
          class="control-display"
          *ngIf="equipmentServ.filteredIconsList.length > 0"
        >
          <ion-label> {{ "EQUIPMENT.ICON" | translate }}</ion-label>
          <app-select-dropdown
            formControlName="iconName"
            [data]="equipmentServ.filteredIconsList"
          ></app-select-dropdown>
        </div>

        <ion-item class="input" lines="none">
          <ion-button
            *ngIf="idEquipment != 0"
            class="button-margin-top-md"
            slot="start"
            fill="outline"
            size="medium"
            color="primary"
            (click)="delete()"
            >{{ "DELETE" | translate }}</ion-button
          >
          <ion-button
            class="button-margin-top-md"
            (click)="onSave()"
            size="medium"
            slot="end"
            [disabled]="disableSaveButton"
          >
            <ng-container *ngIf="!disableSaveButton">{{
              "SAVE" | translate
            }}</ng-container>
            <ng-container *ngIf="disableSaveButton">{{
              "SAVING" | translate
            }}</ng-container>
          </ion-button>
        </ion-item>
      </form>
    </div>
  </div>
</ion-content>

<app-loading-sti *ngIf="loading"></app-loading-sti>
